import { AddIcon } from "@chakra-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "../Common/CustomButton";
import { SearchBar } from "../navbar/searchBar/SearchBar";

interface DebouncedSearchProps {
  value: string;
  onChange: (val: string) => void;
  handleAddNew: () => void;
  hideAddButton?: boolean;
  showSearch?: boolean;
  filters?: React.ReactNode;
}

export const DebouncedSearch: React.FC<DebouncedSearchProps> = ({
  value,
  onChange,
  handleAddNew,
  hideAddButton,
showSearch,
  filters,
}) => {
  const { t } = useTranslation();
  const handleChange = (e: any) => {
    onChange(e.target.value);
  };

  return (
    <>
      {!showSearch && (
        <SearchBar
          value={value}
          onChange={handleChange}
          h="36px"
          w={{ sm: "190px", lg: "280px" }}
          borderRadius="4px"
        />
      )}

      {filters}
      {!hideAddButton && (
        <CustomButton
          handleClick={handleAddNew}
          title={t("common.button.addNew")}
          leftIcon={<AddIcon />}
          isLeftIcon
        />
      )}
    </>
  );
};
